import React from 'react';
import { JerseyColor } from '../../types/Player';

interface JerseyBadgeProps {
  number?: string;
  color?: JerseyColor;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const colorClasses: Record<JerseyColor, string> = {
  red: 'bg-red-600 text-white',
  blue: 'bg-blue-600 text-white',
};

const unknownClasses = 'bg-gray-200 text-gray-800';

const sizeClasses: Record<NonNullable<JerseyBadgeProps['size']>, string> = {
  sm: 'text-sm px-2 py-0.5 min-w-[2rem]',
  md: 'text-lg px-3 py-1 min-w-[2.5rem]',
  lg: 'text-2xl px-4 py-1.5 min-w-[3.5rem]',
};

const JerseyBadge: React.FC<JerseyBadgeProps> = ({ number, color, size = 'md', className = '' }) => {
  const palette = color ? colorClasses[color] : unknownClasses;
  const display = number ?? '—';
  return (
    <span
      className={`inline-flex items-center justify-center rounded-md font-bold tracking-wider ${palette} ${sizeClasses[size]} ${className}`}
      data-jersey-color={color ?? 'unknown'}
    >
      #{display}
    </span>
  );
};

export default JerseyBadge;
